module.exports = __webpack_public_path__ + "img/illustration-02.d994330b.png";